import React, { useEffect, useState } from "react";
import {
  FiMapPin,
  FiCalendar,
  FiUser,
  FiMinus,
  FiPlus,
  FiSearch,
} from "react-icons/fi";
import InputBox from "../Input/Input-box";
import InputBoxSubHeader from "../Page-2/inputbox-page2";
import LandMarkDropdown from "../Page-2/LandmarkDropdown";

const SubHeader = ({ setSubHeaderQuery, villalist, landmarklist }) => {
  const [selectedLandmark, setSelectedLandmark] = useState("Landmark 1");
  const [sortOrder, setSortOrder] = useState("");
  const [searchVilla, setSearchVilla] = useState("");
  const [villa, setVilla] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleLandmarkChange = (event) => {
    setSelectedLandmark(event.target.value);
  };

  const handleSortOrderChange = (value) => {
    if (value == sortOrder) setSortOrder("");
    else setSortOrder(value);
  };

  const handleSearchVillaChange = (event) => {
    setSearchVilla(event.target.value);
  };

  const handleVillaSearch = () => {
    const input = document.getElementById("villa-input");
    setVilla(input.value);
  };
  const [location, setLocation] = useState(null);
  const [cities, setCities] = useState();

  const handleSelection = async () => {
    const transformedVillaList = villalist.map((villa) => ({
      id: villa.property_ptr_id,
      name: villa.property_name,
      rating: villa.a2z_score || 0,
    }));
    // const res2 = await axios.get(`http://localhost:8000/api/v1/getAllCities`);
    //  setCities(res2.data.data)
    setCities(transformedVillaList);
    // //console.log(res2.data.data);
  };
  useEffect(() => {
    handleSelection();
  }, [villalist]);
  useEffect(() => {
    let query = "";
    if (sortOrder != "") query = `&sortorder=${sortOrder}`;
    location === null
      ? (query += `&property_id=`)
      : (query += `&property_id=${location}`);

    let landmarkQuery = "";

    if (selectedOptions.length > 0) {
      landmarkQuery = "&landmark=";
      selectedOptions.forEach((item, i) => {
        landmarkQuery += `${item}+`;
      });
      landmarkQuery = landmarkQuery.slice(0, -1);
    }
    query += landmarkQuery;

    setSubHeaderQuery(query);
  }, [selectedLandmark, sortOrder, villa, location, selectedOptions]);

  return (
    <div className="sticky top-0 z-[10] font-hk  bg-white py-2 px-4 flex flex-row justify-between shadow-md items-center">
      {/* Dropdown for Landmark Names */}
      <div className="relative w-1/4 mx-3">
        {/* <select
          className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          value={selectedLandmark}
          onChange={handleLandmarkChange}
        >
          <option>Landmark 1</option>
          <option>Landmark 2</option>
          <option>Landmark 3</option>
        </select> */}
        <LandMarkDropdown
          landmarklist={landmarklist}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
        />
      </div>
      {/* Sort Options */}
      <div className="flex flex-row w-1/2 justify-center items-center mx-4">
        <div
          className={`mx-4 px-3 ${
            sortOrder === "asc" ? "bg-[#f1f1f1]  shadow-md  " : ""
          } w-1/3 text-center py-2 rounded-2xl hover:cursor-pointer `}
          onClick={() => handleSortOrderChange("asc")}
        >
          Price (Low to High)
        </div>
        <div
          className={`mx-4 px-3 ${
            sortOrder === "desc" ? "bg-[#f1f1f1]  shadow-md " : ""
          } w-1/3 text-center py-2 rounded-2xl hover:cursor-pointer`}
          onClick={() => handleSortOrderChange("desc")}
        >
          Price (High to Low)
        </div>
        <div
          className={`mx-4 px-3 ${
            sortOrder === "rating" ? "bg-[#f1f1f1]  shadow-md " : ""
          } w-1/3 text-center py-2 rounded-2xl hover:cursor-pointer`}
          onClick={() => handleSortOrderChange("rating")}
        >
          Customer Ratings
        </div>
        {/* <div
          className={`mx-4 px-3 ${
            sortOrder === "rating" ? "bg-[#f1f1f1]  shadow-md " : ""
          } w-1/3 text-center py-2 rounded-2xl hover:cursor-pointer`}
          onClick={() => handleSortOrderChange("rating")}
        >
          Redhomex Villa
        </div> */}
      </div>
      {/* <div className="w-1/4 mx-3 flex flex-row">
        <div>
          <input
            id="villa-input"
            className="border-[1px] w-full shadow-md py-2 px-4 rounded-md leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Search a Villa"
            value={searchVilla}
            onChange={handleSearchVillaChange}
          />
        </div>
        <div
          className="ml-4 bg-black text-white px-4 py-2 rounded-lg"
          onClick={() => {
            handleVillaSearch();
          }}
        >
          <FiSearch />
        </div>
      </div> */}
      {cities && (
        <InputBoxSubHeader
          inputbox={location}
          setInputBox={setLocation}
          cities={cities}
        />
      )}
    </div>
  );
};

export default SubHeader;
